module.exports = __webpack_public_path__ + "img/T-coin.8a2612f.png";